import { BUSINESS, IMAGES } from "../data";
import { Phone, ArrowDown } from "lucide-react";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <img
        src={IMAGES.hero}
        alt="Manicured estate landscape in Dallas, Georgia"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/30" />
      <div className="absolute inset-0 bg-black/20" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <p className="overline text-[#C7D6B8]">{BUSINESS.region}</p>
        <h1 className="font-serif-display text-white text-5xl md:text-6xl lg:text-7xl font-light leading-[0.98] tracking-tight mt-4 max-w-3xl">
          Nature-Rooted Design &amp; Landscaping
        </h1>
        <p className="text-white/90 text-base md:text-lg font-light max-w-xl mt-6 leading-relaxed">
          Thoughtful outdoor spaces, meticulously maintained lawns, and timeless
          hardscapes crafted for homes across Dallas, Georgia.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mt-9">
          <a
            href="#contact"
            data-testid="hero-cta-quote"
            className="rounded-sm bg-[#1E3F20] text-white px-8 py-4 text-sm font-semibold tracking-wide hover:bg-[#2B5A2D] transition-colors text-center"
          >
            Request a Free Quote
          </a>
          <a
            href="#services"
            data-testid="hero-cta-services"
            className="rounded-sm border border-white/50 text-white px-8 py-4 text-sm font-semibold tracking-wide hover:bg-white/10 transition-colors text-center backdrop-blur-sm"
          >
            Explore Services
          </a>
        </div>

        <a
          href={`tel:${BUSINESS.phoneRaw}`}
          data-testid="hero-phone"
          className="inline-flex items-center gap-2 text-white/90 mt-8 text-sm hover:text-white transition-colors"
        >
          <Phone size={16} strokeWidth={1.5} /> {BUSINESS.phone}
        </a>
      </div>

      <div className="absolute bottom-8 right-8 z-10 hidden md:block text-white/60">
        <ArrowDown size={22} strokeWidth={1.5} className="animate-bounce" />
      </div>
    </section>
  );
};
